<template>
  <div>
    <!--If there is data and not mobile, show app bar-->
    <v-app-bar
        v-if="Object.keys(detailedRace).length > 0 && !isMobile"
        class="pa-3 raceinfo"
        color="blue-grey lighten-4"
        style="padding-left:268px !important;max-width:1280px;min-width: 1280px"
        app
        clipped-left
    >
      <v-chip label class="primaryTxt" color="primaryCol mt-n3">
        <img
            :src="raceTypeImg[detailedRace.meeting.type]"
            :alt="detailedRace.meeting.type"
            width="36"
            class="logo mr-2"
            style="filter:invert(100%)"
        />
        <div class="headline font-weight-bold">
          <span>{{detailedRace.meeting.track.name}} R{{detailedRace.number}}</span>
          <span> - {{detailedRace.status}}</span>
        </div>
      </v-chip>
      <div class="heading-4 d-inline font-weight-regular ml-4 pb-2">
        Time:
        <b>{{format(new Date(detailedRace.startTime), 'h:mm a')}}</b>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title class="text-right mt-n3">
      <span
          v-if="detailedRace.trackCondition != 'UNKNOWN_CONDITION'"
          class="ml-2 font-weight-bold"
          :class="['color-' + checkTrackCond(detailedRace.trackCondition)]"
      >{{checkTrackCond(detailedRace.trackCondition)}}</span>
      <span class="ml-2 font-weight-bold primary--text">{{detailedRace.weather}}</span>
      <span class="ml-2 font-weight-bold">{{detailedRace.meeting.track.surface}}</span>
      <div v-if="!greyhoundMeeting(detailedRace) && !harnessMeeting(detailedRace)" style="line-height: 5px; font-size: 15px" class="mb-1 mt-2">
        Rail: <b>{{shortenRail(detailedRace.meeting.railPosition)}}</b>
      </div>
      </v-toolbar-title>
      <template v-slot:extension>
        <div class="mt-n3">
        <span class="primary--text">
          <h3>{{detailedRace.name}}</h3>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            D:
            <b>{{detailedRace.distance}}m</b>
          </div>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            C:
            <b>{{checkClass(detailedRace.class)}}</b>
          </div>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            P:
            <b>${{numeral(detailedRace.prizeMoney).format('0,0a')}}</b>
          </div>
        </span>
        </div>
        <v-spacer></v-spacer>
        <div style="overflow:auto;white-space:nowrap;float:right;">
          <!--Pass bookie codes for DO into buttons (disabled for security)-->
<!--          <div v-if="bestOddsArray.length >= 1">-->
<!--            <v-btn-->
<!--                v-for="r in detailedRace.meeting.races"-->
<!--                :key="r.number"-->
<!--                depressed-->
<!--                fab-->
<!--                x-small-->
<!--                class="caption font-weight-bold white&#45;&#45;text ml-1"-->
<!--                :color="navColor(r.number, detailedRace.number, r.status)"-->
<!--                :href="'/' + gbsID + '/' + r.number + '?codes=' + bookieCodes"-->
<!--            >{{r.number}}</v-btn>-->
<!--          </div>-->
          <div>
            <v-btn
              v-for="r in detailedRace.meeting.races"
              :key="r.number"
              depressed
              fab
              x-small
              class="caption font-weight-bold white--text ml-1"
              :color="navColor(r.number, detailedRace.number, r.status)"
              :href="'/' + gbsID + '/' + r.number"
            >{{r.number}}</v-btn>
          </div>
        </div>
      </template>
    </v-app-bar>
    <!--Coloured bar under app bar-->
    <div v-if="!isMobile" style="height: 5px; width: 1024px; position: fixed; z-index: 999; top: 107px; left: 256px;" class="primaryCol"></div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import numeral from 'numeral'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RaceName',
  data () {
    return {
      numeral,
      format,
      tips: [],
      raceTypeImg: {
        HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
        GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
        THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
      }
    }
  },
  computed: {
    ...mapState(['detailedRace', 'gbsID', 'bestOddsArray']),
    ...mapGetters(['isMobile']),
    bookieCodes () {
      const urlParameters = window.location.search
      const urlParams = new URLSearchParams(urlParameters)
      return urlParams.get('codes')
    }
  },
  methods: {
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    harnessMeeting (data) {
      return data.meeting.type === 'HARNESS'
    },
    shortenRail (string) {
      let shortenedString = string
      if (string.includes('metres')) {
        const newStr = string.split('metres')
        const newStr1 = newStr[0].trim()
        const newStr2 = newStr[1].trim()
        shortenedString = `${newStr1}m${newStr2}`
      }
      return shortenedString
    },
    checkClass: function (x) {
      if (x.includes('HANDICAP=TRUE')) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(',')
        return `${first}, HCP`
      }
      if (x.includes('HANDICAP=FALSE')) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(',')
        return `${first}, HCP`
      }
      return x
    },
    navColor: function (mappedNumber, raceNumber, raceStatus) {
      if (mappedNumber === raceNumber) {
        return '#666'
      } else if (raceStatus === 'OPEN') {
        return '#4caf50'
      } else {
        return '#ff5252'
      }
    },
    checkTrackCond: function (condition) {
      switch (condition) {
        case 'FIRM1':
          return 'Firm 1'
        case 'Firm1':
          return 'Firm 1'
        case 'FIRM2':
          return 'Firm 2'
        case 'Firm2':
          return 'Firm 2'
        case 'GOOD3':
          return 'Good 3'
        case 'Good3':
          return 'Good 3'
        case 'GOOD4':
          return 'Good 4'
        case 'Good4':
          return 'Good 4'
        case 'SOFT5':
          return 'Soft 5'
        case 'Soft5':
          return 'Soft 5'
        case 'SOFT6':
          return 'Soft 6'
        case 'Soft6':
          return 'Soft 6'
        case 'SOFT7':
          return 'Soft 7'
        case 'Soft7':
          return 'Soft 7'
        case 'HEAVY8':
          return 'Heavy 8'
        case 'Heavy8':
          return 'Heavy 8'
        case 'HEAVY9':
          return 'Heavy 9'
        case 'Heavy9':
          return 'Heavy 9'
        case 'HEAVY10':
          return 'Heavy 10'
        case 'Heavy10':
          return 'Heavy 10'
        case 'HEAVY11':
          return 'Heavy 11'
        case 'Heavy11':
          return 'Heavy 11'
        case 'SYNTHETIC' || 'Synthetic':
          return 'Synthetic'
        default:
          return condition
      }
    }
  },
  props: {
    raceFlucs: Object,
    raceComment: String
  }
}
</script>

<style scoped>
::v-deep .v-toolbar__content {
  padding: 0px 0px !important;
  height: 45px !important;
}
::v-deep .v-toolbar__extension {
  padding: 0px 0px !important;
}
.color-Firm {
  color: rgb(0, 204, 255);
}
.color-Firm1 {
  color: rgb(0, 204, 255);
}
.color-Firm2 {
  color: rgb(0, 204, 255);
}
.color-Good {
  color: rgb(0, 219, 0);
}
.color-Good3 {
  color: rgb(0, 219, 0);
}
.color-Good4 {
  color: rgb(0, 219, 0);
}
.color-Soft {
  color: rgb(224, 210, 56);
}
.color-Soft5 {
  color: rgb(224, 210, 56);
}
.color-Soft6 {
  color: rgb(224, 210, 56);
}
.color-Soft7 {
  color: rgb(224, 210, 56);
}
.color-Heavy {
  color: orange;
}
.color-Heavy8 {
  color: orange;
}
.color-Heavy9 {
  color: orange;
}
.color-Heavy10 {
  color: orange;
}
.color-Heavy11 {
  color: orange;
}

.color-Synthetic {
  color: purple;
}
.raceinfo {
  line-height: 25px;
  width: 100%;
  text-align: justify;
  font-size: 14px;
  background-color: white;
  box-shadow: 3px 5px 5px lightgrey;
}
</style>
